import KiosksContainer from './kiosks-container';

export default KiosksContainer;
